import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { CHANGE_PASSWORD } from "../Constants";
import { ChangePasswordActionsFailure, ChangePasswordActionsSuccess } from "../Actions/ChangePassword";

function* ChangePasswordRequest(actions) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_password`,
      {
        current_password: actions.payload.current_password,
        new_password: actions.payload.new_password,
      },
      { headers: { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
    );
    if (res.status === 200) {
      yield put(ChangePasswordActionsSuccess(res.data));
    } else yield put(ChangePasswordActionsFailure(res));
  } catch (e) {
    yield put(ChangePasswordActionsFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(CHANGE_PASSWORD, ChangePasswordRequest);
}

export default function* ChangePasswordSaga() {
  yield all([actionWatcher()]);
}
